import * as React from 'react';

export const FooterNotices = () => (
    <div id="malta-gaming-warning" className="malta-gaming-warning">
        <div className="mg-footer-item">
            <a
                href="https://www.authorisation.mga.org.mt/verification.aspx?lang=EN&company=4debab56-21d5-49fd-96c5-1c2b5500dbb4&details=1"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img src="/images/mga.png" alt="mga logo" />
            </a>
        </div>
        <div className="mg-footer-item">
            <a href="http://rgf.org.mt/" target="_blank" rel="noopener noreferrer">
                <img src="/images/rgf_logo.png" alt="rgf logo" />
            </a>
        </div>
        <div className="mg-footer-item">
            <a href="http://cgaa.info/" target="_blank" rel="noopener noreferrer">
                <img src="/images/2X_18_Icon.png" alt="18+ logo" />
            </a>
        </div>
        <div className="mg-footer-item footer-item-text">
            <a
                className="responsible-gaming-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.chumbacasino.com/responsible-gaming/"
            >
                Gaming is addictive.
                <br />
                Please play responsibly.
            </a>
        </div>
        <div className="mg-footer-item footer-item-text">
            <a
                className="responsible-gaming-link-wide"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.chumbacasino.com/responsible-gaming/"
            >
                {' '}
                Gaming is addictive. Please play responsibly.
            </a>
        </div>
    </div>
);
